import { useEffect, useState } from 'react';

// The composer's waveform takes an AnalyserNode and leaves the AudioContext to its
// caller, so capture owns one here. Browsers cap concurrent AudioContexts, so the
// context is closed whenever the stream goes away rather than only on unmount.
export function useMicAnalyser(stream: MediaStream | null): AnalyserNode | null {
  const [analyser, setAnalyser] = useState<AnalyserNode | null>(null);

  useEffect(() => {
    if (!stream) {
      setAnalyser(null);
      return;
    }
    const context = new AudioContext();
    const node = context.createAnalyser();
    node.fftSize = 2048;
    node.smoothingTimeConstant = 0.85;
    const source = context.createMediaStreamSource(stream);
    source.connect(node);
    void context.resume();
    setAnalyser(node);

    return () => {
      setAnalyser(null);
      source.disconnect();
      node.disconnect();
      void context.close();
    };
  }, [stream]);

  return analyser;
}
